import {ProgressSubItems, RelatedTaskData, RelatedTasks, TaskSystemType} from "../../@types"
import {CLOSED_STATUSES} from "../../../../gd/const/system-status"

export default class TaskProgressSubItems {

    public progressSubItems?    : ProgressSubItems
    public relatedTasks?        : RelatedTasks

    constructor(data: any) {
        this.progressSubItems   = data.progressSubItems
        this.relatedTasks       = data.relatedTasks

        let done    : number = 0
        let total   : number = 0
        _.map(this.relatedTasks?.tasksData, (relatedTaskData: RelatedTaskData) => {
            if (relatedTaskData.systemType === TaskSystemType.SUBTASK) {
                if (CLOSED_STATUSES.includes(relatedTaskData.systemStatus)) {
                    done += 1
                }
                total += 1
            }
        })

        if (total > 0) {
            this.progressSubItems = {
                done    : done,
                total   : total
            }
        }
    }

    get done() {
        return this.progressSubItems?.done
    }

    get total() {
        return this.progressSubItems?.total
    }
}
